<template>
    <div>
        <label class="col-sm-3 col-form-label">Tabs</label>

<!--        <div class="mb-3 col-12">-->
<!--            <label>Location</label>-->

<!--            <select id="typeOptions" class="form-select" v-model="app.nav.location">-->
<!--                <option>top</option>-->
<!--                <option>side</option>-->
<!--                <option>bottom</option>-->
<!--            </select>-->

<!--            <div class="text-muted">for desktop, mobile app will always have bottom navigation</div>-->
<!--        </div>-->


        <div class="col-sm-9">

            <div class="row mt-2" v-for="(tabValue, index) in tabs">
                <div class="col-sm-6">
                    <input type="text" class="form-control" placeholder="label"
                           v-model="tabValue.label">
                </div>
                <div class="col-sm-5">

                    <!-- dropdown -->
                    <div class="btn-group w-100">
                        <button class="btn btn-light btn-sm dropdown" type="button" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                            {{linkLocationLabel(tabValue)}}
                        </button>
                        <div class="dropdown-menu">
                            <div v-if="model.app.id" class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Views</h6>

                            <a v-for="view in views" class="dropdown-item" href="javascript:void(0)"
                               @click="onViewLinkSelected(tabValue, view)"
                               :class="isActiveViewLink(tabValue, view) ? 'active' : ''">{{view.name}}</a>

                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="javascript:void(0)" @click.stop="onUrlSelected(tabValue)"
                               :class="tabValue.resourceType === 'URL' ? 'active' : ''">URL</a>
                            <div class="dropdown-divider"></div>

                            <div v-show="urlVisible(tabValue)" class="form-group">
                                <input type="text" class="form-control" id="viewUrlInput" placeholder="https://"
                                       v-model="tabValue.resource">
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-sm-1">
                    <i class="fa fa-times pointer" @click="onRemoveTabClick(index)"></i>
                </div>

            </div>

            <div class="row mt-2">
                <div class="col-sm-9">
                    <a href="javascript:void(0)" @click="onAddTabClick"
                       class="btn btn-primary btn-sm"
                       style="border-radius: 2rem !important;">add tab</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'NavEditor',
        props: ['app', 'tabs'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            views() {
                let appViews = webase.managers.app.getViews()
                return appViews
            }
        },
        methods: {
            onAddTabClick () {

                this.tabs.push({
                    label: '',
                    resourceType: '',
                    resource: '',
                    resourceName: '',
                })

            },

            onRemoveTabClick (index) {
                this.tabs.splice(index, 1)
            },

            linkLocationLabel(tab) {
                if(tab.resourceName) {
                    return tab.resourceName
                }

                return tab.resource ? tab.resource : 'select'
            },

            isActiveViewLink(tab, view) {
                return tab.resourceType === "View" && tab.resource === view.id
            },

            onViewLinkSelected(tab, view) {
                tab.resourceType = "View"
                tab.resource = view.id
                tab.resourceName = view.name
            },
            onUrlSelected(tab) {
                tab.resourceType = "URL"
                tab.resource = ''
            },
            urlVisible(tab) {
                return tab.resourceType === 'URL'
            },
        }
    }
</script>

<style>

</style>
